import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

import { IconContext } from 'react-icons';
import { ImArrowLeft2 } from 'react-icons/im';

// ========= action import section ========= //
// ====== end of action import section ====== //

// ========= interface import section ========= //
import RouteHistoryInterface from '../../interface/router';
// ====== end of interface import section ====== //

import AccountInfo from './SettingTabs/AccountInfo';
import AddressBook from './SettingTabs/AddressBook';
import BankAccount from './SettingTabs/BankAccount';
import PersonalProfile from './SettingTabs/PersonalProfile';
import SellerLocation from './SettingTabs/SellerLocation';
import UserPreferences from './SettingTabs/UserPreferences';
import ModalUnverifiedUser from 'Pages/Home/Components/Organisms/ModalUnverifiedUser';

type profileSettings = {
  history: RouteHistoryInterface;
  dataAuth: any;
};

type stateToProps = {
  dataAuth: any;
};

const TABS = [
  'Personal Profile',
  'Account Info',
  'Address Book',
  'Bank Account',
  'User Location',
  'User Preferences',
];

/**
 * Profile Setting User Dashboard section for Kick Avenue 3.0 Website.
 * ===============================================
 * @param {profileSettings} props for this component.
 * @return {JSX.Element}
 */
function ProfileSettings({ history, dataAuth }: profileSettings): JSX.Element {
  const [activeTabs, setActiveTabs] = useState(TABS[0]);

  const [isShowModal, setIsShowModal] = useState(false);
  const [unverifiedType, setUnverifiedType] =
    useState<
      'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account'
    >('Top Up');

  const onClickUnverifiedUser = (
    val: 'Top Up' | 'Cash Out' | 'Add your Address' | 'Set your Bank Account',
  ) => {
    setIsShowModal(true);
    setUnverifiedType(val);
  };

  /**
   * Function for handling tab changes
   * @param {string} targetTab target tab for changing to active.
   */
  function handleChangeTabs(targetTab: string) {
    if (
      targetTab === 'Bank Account' &&
      dataAuth.userdata.roles.includes('unverified_user')
    ) {
      onClickUnverifiedUser('Set your Bank Account');
      return;
    }
    if (
      targetTab === 'Address Book' &&
      dataAuth.userdata.roles.includes('unverified_user')
    ) {
      onClickUnverifiedUser('Add your Address');
      return;
    }
    setActiveTabs(targetTab);
  }

  /**
   * Function for rendering tabs data
   * @param {string} currentActiveTab current active tab from state.
   * @return {JSX.Element} react element
   */
  function renderTabContent(currentActiveTab: string) {
    switch (currentActiveTab) {
      case 'Personal Profile':
        return <PersonalProfile />;
      case 'Account Info':
        return <AccountInfo />;
      case 'Address Book':
        return <AddressBook />;
      case 'Bank Account':
        return <BankAccount />;
      case 'User Location':
        return <SellerLocation />;
      case 'User Preferences':
        return <UserPreferences />;
      default:
        return;
    }
  }

  const onClickBack = () => {
    history.push({ pathname: `/user_dashboard` });
  };

  return (
    <div className={'buying-container'}>
      <div className={'title-container'}>
        <div className={'back-button setting'} onClick={onClickBack}>
          <IconContext.Provider value={{ color: '#242424', size: '15px' }}>
            <div>
              <ImArrowLeft2 />
            </div>
          </IconContext.Provider>
        </div>
        <span className={'title setting'}>Settings</span>
      </div>
      <div className={'tab-container no-padding'}>
        {TABS.map((t) => {
          let classDiv = 'tabs';
          if (activeTabs === t) classDiv += ' active';
          return (
            <div
              key={t}
              className={classDiv}
              onClick={() => handleChangeTabs(t)}
            >
              <p>{t}</p>
              {activeTabs === t && <div className={'is-active-tabs'} />}
            </div>
          );
        })}
      </div>
      <div className={'tab-content'}>{renderTabContent(activeTabs)}</div>
      <ModalUnverifiedUser
        type={unverifiedType}
        isShow={isShowModal}
        setIsShow={setIsShowModal}
      />
    </div>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {
    dataAuth: state.dataAuth,
  };
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileSettings);
